export default "<div class=\"menu-block {{class}}\" {{attrIfValue \"id\" id}}>\n    {{> @partial-block }}\n</div>";